// extracted by mini-css-extract-plugin
module.exports = {"superInput":"SuperInput_superInput__1GUOs","errorInput":"SuperInput_errorInput__2SR5j","error":"SuperInput_error__2FQdm"};